<template>
    <div>
        <iframe :src="targetUrl" width="100%" height="600px" frameborder="0"></iframe>
    </div>
</template>

<script>
export default {
    data() {
        return {
            targetUrl: `http://intranetuat.bla.co.th/OnlineAgentRegister?auth=${this.token}`,
            token: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjbGFpbTEiOiIyeW5BZEdoZ0xrS2J4S1JLaWhxSEhRPT0ifQ.uXpxEA89fhr6L2rHQxeSE5kVIsTwhnzY84bRfbI4FKI"  // token ที่ต้องการส่ง
        }
    },
    mounted() {
        this.token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjbGFpbTEiOiIyeW5BZEdoZ0xrS2J4S1JLaWhxSEhRPT0ifQ.uXpxEA89fhr6L2rHQxeSE5kVIsTwhnzY84bRfbI4FKI';
        this.targetUrl = `http://intranetuat.bla.co.th/OnlineAgentRegister?auth=${this.token}`;
        console.log(this.targetUrl);
    },
}
</script>